import { addressQuery } from 'api'

/**
 * Initial state
 */
const state = {
}

/**
 * Getters
 */
const getters = {
}

/**
 * Actions
 */
const actions = {
  search ({ commit, state, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      addressQuery
        .search({ params: payload.params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          let message = err.response.data.message;
          reject(message);
        });
    });
  }
}

/**
 * Mutations
 */
const mutations = {
}

/**
 * Getters, Actions and Mutations are registered
 * with namespace
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
